import { createSlot } from "lib/@components/slot/create-slot"

export const PlannerDetails = createSlot("PlannerDetails")
